
export * from '../../item-selector-taglib/__liferay__/index.js';
